import React from "react";

export function CreateAccountSvg() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 28C24.66 28 14 30.66 14 36V40H46V36C46 30.66 35.34 28 30 28ZM12 20V14H8V20H2V24H8V30H12V24H18V20M30 24C32.1217 24 34.1566 23.1571 35.6569 21.6569C37.1571 20.1566 38 18.1217 38 16C38 13.8783 37.1571 11.8434 35.6569 10.3431C34.1566 8.84285 32.1217 8 30 8C27.8783 8 25.8434 8.84285 24.3431 10.3431C22.8429 11.8434 22 13.8783 22 16C22 18.1217 22.8429 20.1566 24.3431 21.6569C25.8434 23.1571 27.8783 24 30 24Z"
        fill="#FF6633"
      />
    </svg>
  );
}

export function JobsSvg() {
  return (
    <svg
      width="39"
      height="38"
      viewBox="0 0 39 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.8916 20.0107V32.9587H4.2872V20.0107M19.5894 25.8962V21.1878M24.2978 9.41687C24.2978 9.41687 24.2978 4.7085 19.5894 4.7085C14.881 4.7085 14.881 9.41687 14.881 9.41687M3.11011 9.41687H36.0687V18.8336C36.0687 18.8336 29.0062 23.542 19.5894 23.542C10.1727 23.542 3.11011 18.8336 3.11011 18.8336V9.41687Z"
        stroke="#FF6633"
        stroke-width="2.82502"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function InterviewSvg() {
  return (
    <svg
      width="42"
      height="34"
      viewBox="0 0 42 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3333 19.5607C15.4143 19.5607 19.5333 15.4358 19.5333 10.3474C19.5333 5.25898 15.4143 1.13403 10.3333 1.13403C5.25228 1.13403 1.1333 5.25898 1.1333 10.3474C1.1333 15.4358 5.25228 19.5607 10.3333 19.5607Z"
        fill="#FF6633"
        stroke="#FF6633"
        stroke-width="0.666667"
        stroke-miterlimit="10"
      />
      <path
        d="M9.26525 19.6068C7.16259 22.4988 4.33325 23.6668 0.333252 23.6668C2.24925 22.3895 4.16525 19.8881 4.90925 17.9221L9.26525 19.6068Z"
        fill="#FF6633"
      />
      <path
        d="M31.6666 29.7201C36.7476 29.7201 40.8666 25.6011 40.8666 20.5201C40.8666 15.439 36.7476 11.3201 31.6666 11.3201C26.5855 11.3201 22.4666 15.439 22.4666 20.5201C22.4666 25.6011 26.5855 29.7201 31.6666 29.7201Z"
        fill="#FF6633"
        stroke="#FF6633"
        stroke-width="0.666667"
        stroke-miterlimit="10"
      />
      <path
        d="M32.7344 29.7933C34.837 32.6853 37.6664 33.8533 41.6664 33.8533C39.7504 32.576 37.8344 30.0746 37.0904 28.1086L32.7344 29.7933Z"
        fill="#FF6633"
      />
    </svg>
  );
}

export function InfinitySvg(props) {
  return (
    <svg
      viewBox="0 0 85 85"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M82.3438 42.4999C82.3441 46.1776 81.2537 49.7727 79.2106 52.8307C77.1675 55.8887 74.2635 58.2721 70.8658 59.6795C67.468 61.087 63.7293 61.4552 60.1222 60.7376C56.5152 60.0201 53.202 58.249 50.6016 55.6483L50.4921 55.5321L30.5868 33.0536C28.7232 31.2118 26.3565 29.9624 23.7845 29.4625C21.2125 28.9627 18.5501 29.2348 16.1323 30.2446C13.7146 31.2544 11.6496 32.9568 10.1971 35.1375C8.74463 37.3182 7.96963 39.8797 7.96963 42.4999C7.96963 45.12 8.74463 47.6816 10.1971 49.8623C11.6496 52.043 13.7146 53.7454 16.1323 54.7552C18.5501 55.765 21.2125 56.0371 23.7845 55.5372C26.3565 55.0374 28.7232 53.788 30.5868 51.9462L33.4157 48.752C33.8829 48.2237 34.5408 47.9025 35.2447 47.8593C35.9487 47.816 36.641 48.0541 37.1693 48.5213C37.6977 48.9884 38.0188 49.6463 38.0621 50.3503C38.1054 51.0542 37.8672 51.7465 37.4001 52.2749L34.5147 55.5321L34.4052 55.6483C31.8047 58.2485 28.4916 60.0192 24.8848 60.7365C21.278 61.4538 17.5396 61.0855 14.1421 59.6781C10.7446 58.2707 7.84081 55.8875 5.79779 52.8298C3.75476 49.7721 2.66431 46.1773 2.66431 42.4999C2.66431 38.8225 3.75476 35.2276 5.79779 32.1699C7.84081 29.1123 10.7446 26.7291 14.1421 25.3217C17.5396 23.9143 21.278 23.546 24.8848 24.2633C28.4916 24.9806 31.8047 26.7513 34.4052 29.3514L34.5147 29.4677L54.42 51.9462C56.2836 53.788 58.6503 55.0374 61.2223 55.5372C63.7943 56.0371 66.4567 55.765 68.8745 54.7552C71.2922 53.7454 73.3572 52.043 74.8097 49.8623C76.2622 47.6816 77.0372 45.12 77.0372 42.4999C77.0372 39.8797 76.2622 37.3182 74.8097 35.1375C73.3572 32.9568 71.2922 31.2544 68.8745 30.2446C66.4567 29.2348 63.7943 28.9627 61.2223 29.4625C58.6503 29.9624 56.2836 31.2118 54.42 33.0536L51.5911 36.2477C51.1239 36.7761 50.466 37.0972 49.7621 37.1405C49.0581 37.1838 48.3658 36.9457 47.8375 36.4785C47.3091 36.0113 46.988 35.3534 46.9447 34.6495C46.9014 33.9455 47.1396 33.2532 47.6067 32.7249L50.4921 29.4677L50.6016 29.3514C53.202 26.7508 56.5152 24.9797 60.1222 24.2621C63.7293 23.5446 67.468 23.9128 70.8658 25.3202C74.2635 26.7277 77.1675 29.1111 79.2106 32.169C81.2537 35.227 82.3441 38.8222 82.3438 42.4999Z"
        fill="#F24E1E"
      />
    </svg>
  );
}

export function HighlightSvg() {
  return (
    <svg
      width="59"
      height="55"
      viewBox="0 0 59 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.4253 52.1878C15.7071 46.0576 10.0416 37.4115 9.12953 25.7364"
        stroke="white"
        stroke-width="5"
        stroke-linecap="round"
      />
      <path
        d="M56.2797 46.9159C47.6348 41.9554 28.4001 28.8889 20.6197 16.3071"
        stroke="white"
        stroke-width="5"
        stroke-linecap="round"
      />
      <path
        d="M27.5973 5.8138C33.148 7.21253 45.1756 10.8049 48.8799 13.9845"
        stroke="white"
        stroke-width="5"
        stroke-linecap="round"
      />
    </svg>
  );
}

export function TickSvg({className}) {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.99996 0.641357C4.48608 0.641357 0 5.12629 0 10.6413C0 16.1553 4.48608 20.6408 9.99996 20.6408C15.5138 20.6408 20 16.1553 20 10.6413C20 5.12629 15.5138 0.641357 9.99996 0.641357ZM15.575 7.30639L9.42112 14.2295C9.2696 14.3994 9.05846 14.487 8.84571 14.487C8.67691 14.487 8.50731 14.4317 8.3654 14.3193L4.51916 11.2419C4.18761 10.9768 4.13384 10.4924 4.39921 10.1602C4.66426 9.82898 5.1488 9.77468 5.48035 10.0403L8.7561 12.6607L14.4249 6.28381C14.7066 5.96554 15.1934 5.93704 15.5107 6.21985C15.8284 6.5021 15.8573 6.98812 15.575 7.30639Z"
        fill="#5843BD"
      />
    </svg>
  );
}

export function MoilSvg() {
  return <img src='https://res.cloudinary.com/drlcisipo/image/upload/v1705704269/Website%20images/moil_logo_q8y4uq.svg' alt="moil logo" width={21} height={35} />;
}

export function LinkedInSvg() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.042 0.347747H2.58299C2.11879 0.343023 1.67167 0.522641 1.33975 0.847189C1.00783 1.17174 0.818207 1.6147 0.8125 2.07889V22.6205C0.819239 23.084 1.00931 23.526 1.34112 23.8497C1.67294 24.1734 2.11946 24.3525 2.58299 24.3477H23.042C23.5062 24.3514 23.9531 24.1712 24.2848 23.8465C24.6166 23.5217 24.8063 23.0788 24.8125 22.6146V2.07299C24.8042 1.61016 24.6136 1.16931 24.2821 0.84625C23.9505 0.523192 23.5049 0.344045 23.042 0.347747Z"
        fill="#0076B2"
      />
      <path
        d="M4.36629 9.34408H7.92891V20.807H4.36629V9.34408ZM6.14858 3.63916C6.5572 3.63916 6.95663 3.76035 7.29636 3.98741C7.63608 4.21446 7.90083 4.53718 8.05711 4.91473C8.21339 5.29228 8.25418 5.7077 8.17432 6.10843C8.09446 6.50917 7.89754 6.87721 7.60847 7.16601C7.31939 7.45481 6.95116 7.65138 6.55035 7.73086C6.14954 7.81034 5.73416 7.76915 5.35676 7.61251C4.97936 7.45587 4.6569 7.19081 4.43016 6.85087C4.20343 6.51093 4.08262 6.11138 4.08301 5.70277C4.08353 5.15528 4.30138 4.6304 4.6887 4.24346C5.07601 3.85651 5.6011 3.63916 6.14858 3.63916Z"
        fill="white"
      />
      <path
        d="M10.1636 9.3438H13.5787V10.9176H13.6259C14.1019 10.0166 15.2626 9.06643 16.9957 9.06643C20.6036 9.05856 21.2724 11.433 21.2724 14.5117V20.8068H17.7098V15.2297C17.7098 13.9018 17.6862 12.1923 15.8587 12.1923C14.0311 12.1923 13.7203 13.6402 13.7203 15.1431V20.8068H10.1636V9.3438Z"
        fill="white"
      />
    </svg>
  );
}

export function FacebookSvg() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.2125 0.347656H4.4125C2.42427 0.347656 0.8125 1.95943 0.8125 3.94766V20.7477C0.8125 22.7359 2.42427 24.3477 4.4125 24.3477H21.2125C23.2007 24.3477 24.8125 22.7359 24.8125 20.7477V3.94766C24.8125 1.95943 23.2007 0.347656 21.2125 0.347656Z"
        fill="#1877F2"
      />
      <path
        d="M17.4812 15.8164L18.0156 12.3477H14.6875V10.0977C14.6875 9.15078 15.1516 8.22266 16.6422 8.22266H18.1562V5.26953C18.1562 5.26953 16.7828 5.03516 15.4703 5.03516C12.7281 5.03516 10.9375 6.69453 10.9375 9.70391V12.3477H7.89062V15.8164H10.9375V24.3477H14.6875V15.8164H17.4812Z"
        fill="white"
      />
    </svg>
  );
}

export function InstagramSvg() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.2125 0.347656H4.4125C2.42427 0.347656 0.8125 1.95943 0.8125 3.94766V20.7477C0.8125 22.7359 2.42427 24.3477 4.4125 24.3477H21.2125C23.2007 24.3477 24.8125 22.7359 24.8125 20.7477V3.94766C24.8125 1.95943 23.2007 0.347656 21.2125 0.347656Z"
        fill="black"
      />
      <path
        d="M21.2125 0.347656H4.4125C2.42427 0.347656 0.8125 1.95943 0.8125 3.94766V20.7477C0.8125 22.7359 2.42427 24.3477 4.4125 24.3477H21.2125C23.2007 24.3477 24.8125 22.7359 24.8125 20.7477V3.94766C24.8125 1.95943 23.2007 0.347656 21.2125 0.347656Z"
        fill="url(#paint0_radial_2313_4511)"
      />
      <path
        d="M21.2125 0.347656H4.4125C2.42427 0.347656 0.8125 1.95943 0.8125 3.94766V20.7477C0.8125 22.7359 2.42427 24.3477 4.4125 24.3477H21.2125C23.2007 24.3477 24.8125 22.7359 24.8125 20.7477V3.94766C24.8125 1.95943 23.2007 0.347656 21.2125 0.347656Z"
        fill="url(#paint1_linear_2313_4511)"
      />
      <path
        d="M16.2349 5.12891H9.39111C7.29416 5.12891 5.59424 6.82882 5.59424 8.92578V15.7695C5.59424 17.8665 7.29416 19.5664 9.39111 19.5664H16.2349C18.3318 19.5664 20.0317 17.8665 20.0317 15.7695V8.92578C20.0317 6.82882 18.3318 5.12891 16.2349 5.12891Z"
        stroke="white"
        stroke-width="1.3697"
      />
      <path
        d="M12.8132 15.7227C14.6772 15.7227 16.1882 14.2116 16.1882 12.3477C16.1882 10.4837 14.6772 8.97266 12.8132 8.97266C10.9493 8.97266 9.43823 10.4837 9.43823 12.3477C9.43823 14.2116 10.9493 15.7227 12.8132 15.7227Z"
        stroke="white"
        stroke-width="1.3697"
      />
      <path
        d="M17.0789 8.36342C17.2343 8.36342 17.3602 8.23747 17.3602 8.0821C17.3602 7.92673 17.2343 7.80078 17.0789 7.80078C16.9236 7.80078 16.7976 7.92673 16.7976 8.0821C16.7976 8.23747 16.9236 8.36342 17.0789 8.36342Z"
        stroke="white"
        stroke-width="1.3697"
      />
      <defs>
        <radialGradient
          id="paint0_radial_2313_4511"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.4125 24.3477) scale(24)"
        >
          <stop offset="0.1" stop-color="#FFDD55" />
          <stop offset="0.5" stop-color="#FF543E" />
          <stop offset="1" stop-color="#C837AB" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_2313_4511"
          x1="0.8125"
          y1="0.347656"
          x2="5.6125"
          y2="24.3477"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#3771C8" />
          <stop offset="0.5" stop-color="#6600FF" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function XSvg() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2313_4519)">
        <path
          d="M15.0958 10.4516L24.0303 0H21.9131L14.1552 9.07494L7.95906 0H0.8125L10.1823 13.7229L0.8125 24.683H2.92982L11.1223 15.0995L17.6659 24.683H24.8125L15.0952 10.4516H15.0958ZM12.1958 13.8438L11.2464 12.4773L3.69272 1.604H6.9448L13.0407 10.3791L13.9901 11.7456L21.9141 23.1519H18.662L12.1958 13.8443V13.8438Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_2313_4519">
          <rect
            width="24"
            height="24.6957"
            fill="white"
            transform="translate(0.8125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function MobileSvg() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 3.75C2 3.55109 2.07902 3.36032 2.21967 3.21967C2.36032 3.07902 2.55109 3 2.75 3H13.25C13.4489 3 13.6397 3.07902 13.7803 3.21967C13.921 3.36032 14 3.55109 14 3.75C14 3.94891 13.921 4.13968 13.7803 4.28033C13.6397 4.42098 13.4489 4.5 13.25 4.5H2.75C2.55109 4.5 2.36032 4.42098 2.21967 4.28033C2.07902 4.13968 2 3.94891 2 3.75ZM2 7.75C2 7.55109 2.07902 7.36032 2.21967 7.21967C2.36032 7.07902 2.55109 7 2.75 7H13.25C13.4489 7 13.6397 7.07902 13.7803 7.21967C13.921 7.36032 14 7.55109 14 7.75C14 7.94891 13.921 8.13968 13.7803 8.28033C13.6397 8.42098 13.4489 8.5 13.25 8.5H2.75C2.55109 8.5 2.36032 8.42098 2.21967 8.28033C2.07902 8.13968 2 7.94891 2 7.75ZM2 11.75C2 11.5511 2.07902 11.3603 2.21967 11.2197C2.36032 11.079 2.55109 11 2.75 11H13.25C13.4489 11 13.6397 11.079 13.7803 11.2197C13.921 11.3603 14 11.5511 14 11.75C14 11.9489 13.921 12.1397 13.7803 12.2803C13.6397 12.421 13.4489 12.5 13.25 12.5H2.75C2.55109 12.5 2.36032 12.421 2.21967 12.2803C2.07902 12.1397 2 11.9489 2 11.75Z"
        fill="#AAAAAA"
      />
    </svg>
  );
}

export function TranslatSvg() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.56489 14.4404C9.00179 14.8807 9.24696 15.4757 9.24696 16.096C9.24696 16.7162 9.00179 17.3113 8.56489 17.7515L7.26643 19.05C7.19368 19.1221 7.10742 19.1793 7.01258 19.2181C6.91774 19.257 6.81618 19.2768 6.71369 19.2764C6.6112 19.276 6.5098 19.2554 6.41527 19.2158C6.32073 19.1762 6.23493 19.1184 6.16274 19.0456C6.09055 18.9729 6.03341 18.8866 5.99456 18.7918C5.95571 18.6969 5.93592 18.5954 5.93632 18.4929C5.93672 18.3904 5.95731 18.289 5.9969 18.1945C6.03649 18.0999 6.09431 18.0141 6.16707 17.9419L7.46553 16.6435C7.53724 16.5719 7.59414 16.4869 7.63296 16.3933C7.67178 16.2998 7.69176 16.1994 7.69176 16.0981C7.69176 15.9968 7.67178 15.8965 7.63296 15.8029C7.59414 15.7093 7.53724 15.6243 7.46553 15.5528L6.16707 14.2889C6.0324 14.1414 5.95917 13.948 5.96235 13.7483C5.96552 13.5486 6.04487 13.3576 6.18417 13.2145C6.32346 13.0713 6.51218 12.9867 6.71174 12.9781C6.91129 12.9694 7.10662 13.0374 7.25778 13.1679L8.55624 14.4361L8.56489 14.4404ZM6.16707 16.0245C6.16707 15.8168 6.08453 15.6175 5.93761 15.4706C5.7907 15.3237 5.59144 15.2411 5.38366 15.2411H4.68249C3.85555 15.2412 3.06221 14.9138 2.47585 14.3307C1.88949 13.7476 1.55778 12.9561 1.5532 12.1292V10.2897C1.53852 10.0925 1.44984 9.90821 1.30494 9.77371C1.16005 9.63921 0.969662 9.56446 0.771963 9.56446C0.574264 9.56446 0.383876 9.63921 0.238983 9.77371C0.0940896 9.90821 0.00540735 10.0925 -0.00927734 10.2897V12.1292C-0.00584605 13.372 0.489704 14.563 1.36896 15.4414C2.24822 16.3199 3.43961 16.8143 4.68249 16.8166H5.38366C5.48727 16.8166 5.58986 16.7961 5.68547 16.7562C5.78109 16.7162 5.86784 16.6578 5.9407 16.5841C6.01356 16.5104 6.07108 16.423 6.10994 16.327C6.1488 16.231 6.16821 16.1282 6.16707 16.0245ZM13.841 5.81864L12.5425 4.55481C12.4003 4.41064 12.3206 4.21628 12.3206 4.01378C12.3206 3.81128 12.4003 3.61693 12.5425 3.47276L13.841 2.1743C13.9211 2.1036 13.986 2.01725 14.0315 1.92056C14.0771 1.82387 14.1024 1.71887 14.1058 1.61205C14.1093 1.50522 14.0908 1.39881 14.0516 1.29938C14.0124 1.19994 13.9533 1.10958 13.8779 1.03386C13.8024 0.958131 13.7123 0.898641 13.613 0.859049C13.5137 0.819456 13.4074 0.800598 13.3006 0.803635C13.1937 0.806672 13.0886 0.831539 12.9918 0.876708C12.8949 0.921876 12.8083 0.986389 12.7373 1.06628L11.4388 2.36474C10.9998 2.80385 10.7532 3.39935 10.7532 4.02028C10.7532 4.6412 10.9998 5.2367 11.4388 5.67581L12.7373 6.94398C12.8112 7.01645 12.8986 7.07365 12.9946 7.11233C13.0906 7.151 13.1933 7.17039 13.2968 7.16939C13.4003 7.16839 13.5026 7.14701 13.5978 7.10647C13.693 7.06594 13.7793 7.00705 13.8518 6.93316C13.9243 6.85927 13.9815 6.77183 14.0201 6.67583C14.0588 6.57983 14.0782 6.47715 14.0772 6.37366C14.0762 6.27017 14.0548 6.16789 14.0143 6.07266C13.9738 5.97743 13.9149 5.89111 13.841 5.81864ZM15.3255 3.29097C16.5662 3.29783 17.7538 3.79489 18.6294 4.67378C19.5051 5.55267 19.9977 6.7421 20 7.98275V9.8179C19.9853 10.0151 19.8966 10.1994 19.7517 10.3339C19.6069 10.4684 19.4165 10.5431 19.2188 10.5431C19.0211 10.5431 18.8307 10.4684 18.6858 10.3339C18.5409 10.1994 18.4522 10.0151 18.4375 9.8179V7.98275C18.4364 7.15356 18.1062 6.35872 17.5194 5.7728C16.9327 5.18688 16.1374 4.85778 15.3082 4.85778H14.6071C14.3993 4.85778 14.2 4.77525 14.0531 4.62833C13.9062 4.48141 13.8237 4.28215 13.8237 4.07438C13.8237 3.86661 13.9062 3.66735 14.0531 3.52043C14.2 3.37351 14.3993 3.29097 14.6071 3.29097H15.3255ZM7.5997 1.40388C7.49148 1.00106 7.25343 0.645174 6.92243 0.391367C6.59144 0.13756 6.18598 0 5.76887 0C5.35177 0 4.94631 0.13756 4.61531 0.391367C4.28432 0.645174 4.04627 1.00106 3.93804 1.40388L2.66988 6.93532C2.63828 7.13155 2.68245 7.33245 2.79344 7.49733C2.90443 7.66222 3.07395 7.77875 3.26764 7.82332C3.46134 7.86789 3.66473 7.83717 3.83663 7.73739C4.00852 7.6376 4.13606 7.47621 4.19341 7.2859L4.40982 6.32937H7.16688L7.39628 7.29023C7.41457 7.39525 7.45411 7.49542 7.51246 7.58463C7.57082 7.67383 7.64676 7.75019 7.73565 7.80902C7.82453 7.86786 7.92449 7.90794 8.02941 7.9268C8.13432 7.94567 8.24198 7.94292 8.34579 7.91874C8.44961 7.89456 8.5474 7.84944 8.63317 7.78615C8.71895 7.72287 8.7909 7.64274 8.84464 7.55068C8.89837 7.45862 8.93276 7.35656 8.94568 7.25075C8.9586 7.14494 8.9498 7.03761 8.9198 6.93532L7.5997 1.40388ZM4.75175 4.77122L5.42262 1.84535C5.43786 1.76876 5.47919 1.69981 5.53956 1.65027C5.59994 1.60072 5.67562 1.57364 5.75372 1.57364C5.83183 1.57364 5.90751 1.60072 5.96789 1.65027C6.02826 1.69981 6.06959 1.76876 6.08483 1.84535L6.79899 4.77122H4.75175ZM16.3903 17.4485C16.2555 17.6404 16.111 17.8253 15.9575 18.0025C16.5258 18.2998 17.16 18.4486 17.8013 18.4354C17.9088 18.4273 18.0167 18.4416 18.1185 18.4772C18.2202 18.5129 18.3135 18.5691 18.3924 18.6424C18.4714 18.7158 18.5345 18.8046 18.5775 18.9034C18.6206 19.0022 18.6429 19.1088 18.6429 19.2166C18.6429 19.3244 18.6206 19.431 18.5775 19.5298C18.5345 19.6286 18.4714 19.7174 18.3924 19.7908C18.3135 19.8641 18.2202 19.9203 18.1185 19.9559C18.0167 19.9916 17.9088 20.0058 17.8013 19.9978C16.7214 20.0039 15.665 19.6825 14.7715 19.0759C13.879 19.6845 12.822 20.0061 11.7418 19.9978C11.6343 20.0058 11.5263 19.9916 11.4246 19.9559C11.3229 19.9203 11.2296 19.8641 11.1506 19.7908C11.0716 19.7174 11.0086 19.6286 10.9655 19.5298C10.9224 19.431 10.9002 19.3244 10.9002 19.2166C10.9002 19.1088 10.9224 19.0022 10.9655 18.9034C11.0086 18.8046 11.0716 18.7158 11.1506 18.6424C11.2296 18.5691 11.3229 18.5129 11.4246 18.4772C11.5263 18.4416 11.6343 18.4273 11.7418 18.4354C12.3815 18.4475 13.0141 18.2987 13.5813 18.0025C13.3308 17.7055 13.105 17.3885 12.9061 17.0547C12.8442 16.9665 12.8011 16.8664 12.7796 16.7608C12.7581 16.6552 12.7586 16.5463 12.7811 16.4409C12.8036 16.3356 12.8476 16.2359 12.9103 16.1483C12.9731 16.0607 13.0532 15.987 13.1458 15.9318C13.2383 15.8765 13.3412 15.841 13.4481 15.8274C13.555 15.8137 13.6636 15.8223 13.767 15.8525C13.8705 15.8828 13.9666 15.934 14.0493 16.0031C14.132 16.0722 14.1996 16.1576 14.2478 16.2539C14.4059 16.5192 14.5854 16.7711 14.7845 17.007C14.9063 16.8691 15.0204 16.7246 15.1264 16.5742C15.5569 15.9364 15.8705 15.227 16.0527 14.4794H11.4821C11.2849 14.4647 11.1006 14.376 10.9661 14.2311C10.8316 14.0862 10.7569 13.8958 10.7569 13.6981C10.7569 13.5004 10.8316 13.3101 10.9661 13.1652C11.1006 13.0203 11.2849 12.9316 11.4821 12.9169H14.0184V12.1292C14.0429 11.9404 14.1352 11.767 14.2782 11.6414C14.4212 11.5157 14.605 11.4464 14.7953 11.4464C14.9857 11.4464 15.1695 11.5157 15.3125 11.6414C15.4555 11.767 15.5478 11.9404 15.5723 12.1292V12.9082H18.0307C18.2278 12.9229 18.4121 13.0116 18.5466 13.1565C18.6811 13.3014 18.7559 13.4918 18.7559 13.6895C18.7559 13.8872 18.6811 14.0776 18.5466 14.2225C18.4121 14.3674 18.2278 14.456 18.0307 14.4707H17.5979C17.4034 15.5384 16.986 16.553 16.373 17.4485H16.3903Z"
        fill="white"
      />
    </svg>
  );
}
